export default "__VITE_ASSET__CgVtWM0S__"